import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-carousel--prev",
  "use": "icon-carousel--prev-usage",
  "viewBox": "0 0 23 25",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 25\" id=\"icon-carousel--prev\"><path d=\"M23 13.59v-2.18H1.206v2.18h21.792Z\" fill=\"currentColor\" /><path d=\"M1.542 14.04 13.099 2.484 11.56.943 0 12.5l1.54 1.54Z\" fill=\"currentColor\" /><path d=\"m11.558 24.057 1.541-1.54L1.542 10.958 0 12.499l11.557 11.558Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol